export default {"src":"/_next/static/media/usdc.6d199ee8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};